import script from "./UserQuestionDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserQuestionDetail.vue?vue&type=script&setup=true&lang=ts"

import "./UserQuestionDetail.vue?vue&type=style&index=0&id=717b203a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-717b203a"]])

export default __exports__